/* eslint-disable */
import React, { useRef, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../Loading';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import api from '../../utils/functions/api';

const RecurringPopup = ({
  open,
  onClose,
  RecurringImage,
  language,
  bank,
  tokens,
  etaxData,
  payType,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const urlOPS = useRef('');
  const formOPS = useRef('');

  const handlePaymentClick = async () => {
    setIsLoading(true);
    try {
      const ReBank = bank[0].bankName;
      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/createpayment`,
        {
          source: `RCRC ${bank} ${etaxData?.branchCode ?? ''} ${
            etaxData?.tax ?? ''
          } ${etaxData?.postalCode ?? ''}`,
          eTaxData: {
            BUYER_NAME: etaxData?.name,
            BUYER_TAX_ID_TYPE: etaxData?.taxpayerType,
            BUYER_TAX_ID: etaxData?.taxId,
            BUYER_BRANCH_ID: etaxData?.branchCode,
            BUYER_POST_CODE: etaxData?.postalCode,
            BUYER_ADDRESS_LINE1: etaxData?.address,
            BUYER_ADDRESS_LINE2: etaxData?.address2,
          },
          recurringCount: etaxData?.recurringCount ?? '',
          recurringInterval: etaxData?.recurringInterval ?? '',
          etaxname: etaxData?.etaxname ?? '',
          etaxaddress1: etaxData?.etaxaddress1 ?? '',
          etaxaddress2: etaxData?.etaxaddress2 ?? '',
          email: etaxData?.email ?? '',
          term: payType === 'IN' ? etaxData?.term : null,
          card_id: etaxData?.select_card?.card_id ?? '',
        },
        { headers: { Authorization: tokens } },
      );
      setIsLoading(false);
      if (data.status === 'paid' && data.company_callback) {
        navigate(
          `/transactionResult?authorization=${tokens}&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'paid' && !data.company_callback) {
        navigate(
          `/transactionResult?status=success&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'pending' && !data.company_callback) {
        navigate(
          `/transactionResult?status=pending&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else if (data.status === 'cancel' && !data.company_callback) {
        navigate(
          `/transactionResult?status=cancel&urlPDF=${encodeURIComponent(
            data.eTaxPDF,
          )}`,
        );
      } else {
        window.location.replace(data.paymentURL);
        urlOPS.current = data.paymentToken;
        formOPS.current = data.paymentURL;
        setTimeout(() => {
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = urlOPS.current;
          form.innerHTML = formOPS.current;
          document.body.appendChild(form);
          form.submit();
        }, 750);
      }
    } catch (error) {
      console.error('Error processing payment:', error);
    }
  };

  const [recurringInterval, setReurringInterval] = useState('');
  const [recurringCount, setRecurringCount] = useState('');
  const [error, setError] = useState(false);

  const handlerereCurringIntervalChange = (event) => {
    setReurringInterval(event.target.value);
    if (error) {
      setError(false); // ล้าง error เมื่อผู้ใช้เริ่มกรอกค่าใหม่
    }
  };

  const handleRecurringCountChange = (event) => {
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      // ตรวจสอบว่าเป็นตัวเลขเท่านั้น
      setRecurringCount(value);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '15px', width: '900px' } }}
    >
      <Loading isLoading={isLoading} />
      <DialogTitle>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
            marginTop: '20px',
            marginLeft: '20px',
          }}
        >
          {language === 'TH'
            ? 'ช่องทางการชำระผ่าน Recurring'
            : 'Recurring Payment Channels'}
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            marginTop: '40px',
            marginBottom: '40px',
            marginLeft: '40px',
            marginRight: '40px',
          }}
        >
          <TextField
            label={
              language === 'TH'
                ? 'กรุณากรอกจำนวนรอบบิล (Recurring)'
                : 'Please enter the number of billing cycles (Recurring)'
            }
            variant="outlined"
            value={recurringCount}
            onChange={handleRecurringCountChange}
            sx={{ width: '100%', marginBottom: '20px' }}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            error={error && !recurringCount} // แสดง error เมื่อไม่มีข้อมูล
            helperText={error && !recurringCount ? 'กรุณากรอกข้อมูล' : ''} // ข้อความ error
          />

          <FormControl
            sx={{ width: '100%' }}
            error={error && !recurringInterval}
          >
            <InputLabel id="recurring">
              {language === 'TH'
                ? 'เลือกระยะเวลาในการตัดรอบบิล (วัน)'
                : 'Select the billing cycle period (days)'}
            </InputLabel>
            <Select
              labelId="recurring"
              value={recurringInterval}
              onChange={handlerereCurringIntervalChange}
              label={
                language === 'TH'
                  ? 'เลือกระยะเวลาในการตัดรอบบิล (วัน)'
                  : 'Select the billing cycle period (days)'
              }
            >
              <MenuItem value={1}>5</MenuItem>
              <MenuItem value={2}>7</MenuItem>
              <MenuItem value={3}>30</MenuItem>
            </Select>
            {error && !recurringInterval && (
              <Typography variant="caption" color="error">
                {language === 'TH'
                  ? 'กรุณาเลือกระยะเวลา'
                  : 'Please select a period'}
              </Typography>
            )}
          </FormControl>
        </Box>
      </DialogContent>

      <DialogActions>
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '40px',
          }}
        >
          <Button
            onClick={onClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยกเลิก' : 'Cancel'}
          </Button>
          <Button
            onClick={() => {
              if (!recurringCount || !recurringInterval) {
                setError(true); // แสดง error หากไม่ได้กรอกข้อมูล
                return;
              }
              handlePaymentClick();
            }}
            disabled={!recurringCount || !recurringInterval} // ปิดใช้งานปุ่มหากข้อมูลไม่ครบ
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            {language === 'TH' ? 'ยืนยัน' : 'Confirm'}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default RecurringPopup;
